import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography, Grid, Card, List, ListItem, ListItemText, Divider, Avatar, } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import PersonIcon from '@mui/icons-material/Person';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';

import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import ModalPopUp from '../../Common/ModalPopUp';

import URLS from '../../../services/urls.service';

const stripHtml = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
};

export default function ServiceRequestStatisticDetailsPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { rowData, trackerId, controlName, controlValue } = location.state || {};
    console.log("rowData", rowData, trackerId, controlName, controlValue)
    const [isLoading, setIsLoading] = useState();
    const [historyData, setHistoryData] = useState([]);
    const [editData, setEditData] = useState([])
    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/reports/servicerequeststatistics', { replace: true });
            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };
    const handleIssueClick = (id) => {
        setSelectedId(id);
        setIsLoading(true);

        // Fetch details
        URLS.editLoadData({ Id: id, TrackerMasterId: trackerId })
            .then((res) => {
                const jsonDataString = JSON.stringify(res.data);
                const modifiedData = JSON.parse(jsonDataString);
                setEditData(modifiedData || []);
            })
            .catch(() => {
                setEditData([]);
            });

        // Fetch history
        URLS.serviceRequestTrackerHistory({ TrackerRequestId: id, TrackerMasterId: trackerId })
            .then((res) => {
                setHistoryData(res.data || []);
            })
            .catch(() => {
                setHistoryData([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const unwantedKeys = ['ID', 'IsDeleted', 'DeletedBy', 'DeletedOn'];

    const raw = editData[0];
    const rawData = editData?.DataTable?.[0] || {};
    const fileKeys = editData?.FileKeys || [];

    const dateFields = ['DateReported', 'TargetedFixDate', 'InsertedAt', 'SystemClosureDate'];

    const issueDetails = Object.entries(rawData)
        .filter(([key]) => !['ID', 'IsDeleted', 'DeletedBy', 'DeletedOn', 'ChildIncidentId', 'ParentIncidentId', 'InsertedBy','EditedBy'].includes(key))
        .sort(([a], [b]) => {
            if (a === 'Issue') return -1;
            if (b === 'Issue') return 1;
            return 0;
        })
        .map(([key, value], index) => {
            let formatted = value ?? '';

            if (value && moment(value).isValid()) {
                if (key === 'InsertedAt') {
                    formatted = moment(value).format('DD-MMM-YYYY - HH:mm');
                } else if (dateFields.includes(key)) {
                    formatted = moment(value).format('DD-MMM-YYYY');
                }
            } else if (dateFields.includes(key)) {
                formatted = '';
            }

            return {
                id: index,
                label: key.replace(/([A-Z])/g, ' $1').trim(),
                value: formatted,
                rawKey: key,
                index,
            };
        });

    const { ID, ChildIncidentId, ParentIncidentId } = rawData || {};

    // Only add if child and parent are not equal
    if (ChildIncidentId !== ParentIncidentId) {
        // Add Child if it exists and is not the same as ID
        if (ChildIncidentId && ChildIncidentId !== ID) {
            issueDetails.push({
                id: issueDetails.length + 1,
                label: 'Child Incident',
                value: ChildIncidentId,
                rawKey: 'ChildIncidentId',
            });
        }

        // Add Parent if it exists
        if (ParentIncidentId) {
            issueDetails.push({
                id: issueDetails.length + 1,
                label: 'Parent Incident',
                value: ParentIncidentId,
                rawKey: 'ParentIncidentId',
            });
        }
    }


    const columns = [
        {
            field: 'label',
            flex: 1,
            renderCell: (params) => {
                const label = params.row.label?.toLowerCase() || '';
                const value = params.row.value;

                // 🔗 Child/Parent Incident clickable label
                if ((label.includes('child incident') || label.includes('parent incident')) && value) {
                    return (
                        <Typography
                            sx={{
                                color: '#4472C4',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontFamily: 'Inter, sans-serif',
                            }}
                            onClick={() => handleIssueClick(value)}
                        >
                            {params.row.label}
                        </Typography>
                    );
                }

                // Default label with colon
                return (
                    <Typography sx={{ fontWeight: 'bold', width: 180, fontFamily: 'Inter, sans-serif' }}>
                        {params.value} :
                    </Typography>
                );
            },
        },
        {
            field: 'value',
            flex: 3,
            renderCell: (params) => {
                const label = params.row.label?.toLowerCase() || '';
                const value = params.row.value || '';
                const {rawKey} = params.row;

                // Don't show value for Child/Parent Incident
                if (rawKey === 'ChildIncidentId' || rawKey === 'ParentIncidentId') {
                    return <></>; // render empty fragment
                }

                if (label.includes('refrence document') && value) {
                    const fileNames = value.split(',').map((name) => name.trim());
                    const fileKeys = editData?.FileKeys || [];

                    return (
                        <div>
                            {fileNames.map((name, idx) => {
                                const fileKey = fileKeys[idx];
                                return (
                                    <a
                                        key={idx}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (fileKey) {
                                                const encodedKey = encodeURIComponent(fileKey);

                                                URLS.downloadServiceFile(encodedKey, { responseType: 'blob' }).then((response) => {
                                                    const url = response.request.responseURL;
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.setAttribute('download', fileKey.split('/').pop());
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                });
                                            }
                                        }}
                                        style={{
                                            color: 'blue',
                                            textDecoration: 'underline',
                                            fontFamily: 'Inter, sans-serif',
                                            display: 'block',
                                            wordBreak: 'break-word',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {name}
                                    </a>
                                );
                            })}
                        </div>
                    );
                }

                // For all other values
                return (
                    <Typography
                        sx={{ wordBreak: 'break-word', fontFamily: 'Inter, sans-serif' }}
                        component="div"
                        dangerouslySetInnerHTML={{ __html: value }}
                    />
                );
            },
        },
    ];


    console.log("eidt",editData)
    const handleBack = () => {
        setOpenModalCancel(true);
    };

    const handleClose = () => {
        setOpenModalCancel(true);

    };

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {/* (Left Panel) */}
            <Box
                sx={{
                    width: 260,
                    backgroundColor: '#fff',
                    borderRight: '1px solid #eee',
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 530,
                }}
            >
                {/* Header with Back + Category */}
                <Box display="flex" alignItems="center" mb={2}>
                    <IconButton onClick={handleBack} size="small">
                        <ArrowBackIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="h6" sx={{ color: '#930F00', ml: 1, fontFamily: 'Inter, sans-serif' }}>
                        {controlName} : {controlValue}
                    </Typography>
                </Box>
                <Divider/>

                {/* Incident List */}
                <Box sx={{
                    flex: 1, overflowY: 'auto',
                    pr: 1,}}>
                    <List>
                        {Array.isArray(rowData) && rowData.map((incident, idx) => (
                            <ListItem
                                key={idx}
                                button
                                onClick={() => handleIssueClick(incident.ID)}
                                sx={{
                                    borderBottom: '1px solid #eee',
                                    '&:last-child': { borderBottom: 'none' },
                                    py: 1,
                                    px: 0,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Box sx={{ width: 24, minWidth: 24, textAlign: 'right', pr: 1 }}>
                                        <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif'} }>{idx + 1}.</Typography>
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#4472C4',
                                            textDecoration: 'underline',
                                            textUnderlineOffset: '3px',
                                            cursor: 'pointer',
                                            ml: 1,
                                            fontFamily: 'Inter, sans-serif'
                                        }}
                                    >
                                        {incident.Issue}
                                    </Typography>
                                </Box>
                            </ListItem>
                        ))}
                    </List>

                </Box>
            </Box>

            {/* Right Main Panel */}
            <Box sx={{ flex: 1, p: 2 }}>
                {/* Top Right Close Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Two Cards Side by Side */}
                <Grid container spacing={2}>
                    {/* Issue Details */}
                    <Grid item xs={12} md={8}>
                        <Card sx={{ height: 430 }}>
                            <DataGrid
                                rows={issueDetails}
                                columns={columns}
                                disableColumnMenu
                                hideFooter
                                disableSelectionOnClick
                                headerHeight={0} 
                                rowHeight={60}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    border: 0,
                                    fontFamily: 'Inter, sans-serif',
                                    '& .MuiDataGrid-columnHeaders': {
                                        display: 'none',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        alignItems: 'start',
                                        py: 1,
                                        fontSize: '14px',
                                        fontFamily: 'Inter, sans-serif',

                                    },
                                }}
                            />

                        </Card>
                    </Grid>

                    {/* History */}
                    <Grid item xs={12} md={4}>
                        <Card sx={{ height: 430, overflow: 'hidden' }}>
                            {/* Header with background color */}
                            <Box sx={{ backgroundColor: '#FFF2F0', px: 2, py: 1 }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Inter, sans-serif' } }>
                                    History
                                </Typography>
                            </Box>

                            <Divider />

                            {/* History List */}
                            <Box sx={{ px: 2, py: 1, maxHeight: 400, overflowY: 'auto' }}>
                                {Array.isArray(historyData) && historyData.map((h, idx) => (
                                    <Box key={idx}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1 }}>
                                            {/* Circle Icon */}
                                            <Box
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    minWidth: 24,
                                                    minHeight: 24,
                                                    borderRadius: '50%',
                                                    border: '1px solid #A08784',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <PersonIcon sx={{ fontSize: 16, color: '#A08784' }} />
                                            </Box>

                                            {/* Text Content */}
                                            <Box sx={{ flex: 1 }}>
                                                <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', fontFamily: 'Inter, sans-serif' }}>
                                                    {h.EditedBy}
                                                    <Typography
                                                        component="span"
                                                        variant="body2"
                                                        sx={{
                                                            fontWeight: 400,
                                                            fontSize: '12px',
                                                            color: 'text.secondary',
                                                            ml: 1,
                                                            fontFamily: 'Inter, sans-serif'
                                                        }}
                                                    >
                                                        {h.EditedDateTime}
                                                    </Typography>
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ mt: 0.5, fontFamily: 'Inter, sans-serif' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: (h.ChangeDetails || '')
                                                            .replace(/{([^}]+)}/g, (_, p1) => `<strong>${p1}</strong>`)
                                                            .replace(/\(([^)]+)\)/g, (_, p1) => `<em>${p1}</em>`)
                                                    }}
                                                />

                                            </Box>
                                        </Box>
                                        <Divider sx={{ mb: 1 }} />
                                    </Box>
                                ))}
                            </Box>
                        </Card>
                    </Grid>


                </Grid>
            </Box>
            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}
            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}

        </Box>

    );
};

